import OspreySilosSearch from './silos-search'
import OspreySilosSearchSuggestion from './silos-search-suggestion'
import OspreySilosMetadata from './silos-metadata'
import OspreySilosGetById from './silos-get-by-id'
import OspreySilosUpdate from './silos-update'

export default class Silos {

    search(dataKey) {
        return new OspreySilosSearch(dataKey)
    }

    getSearchSuggestion(dataKey) {
        return new OspreySilosSearchSuggestion(dataKey)
    }

    getMetadata() {
        return new OspreySilosMetadata()
    }

    getById(...args) {
        return new OspreySilosGetById(...args)
    }

    update(dataKey) {
        return new OspreySilosUpdate(dataKey)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/silos/index.js